<pre 
  contenteditable="true"  
  bind:textContent={json}
  style="padding:1rem;"
  >
</pre>

<script>
  import { onMount } from 'svelte'
  import { buildConfigs } from './config-download-records'
  
  export let 
    recordDef = {},
    settings,
    json = '';

  let dbTables = [];

  //let json = '';

  onMount(() => {
    json = JSON.stringify(buildConfigs(recordDef, settings), null, 2)
  })
</script>

<style>
</style>